import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeftSmall = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M6.3125 9.3125C5.90625 9.6875 5.90625 10.3438 6.3125 10.7188L11.3125 15.7188C11.6875 16.125 12.3438 16.125 12.7188 15.7188C13.125 15.3438 13.125 14.6875 12.7188 14.3125L8.4375 10L12.7188 5.71875C13.125 5.34375 13.125 4.6875 12.7188 4.3125C12.3438 3.90625 11.6875 3.90625 11.3125 4.3125L6.3125 9.3125Z"
	})
});
const ForwardRef = forwardRef(SvgArrowLeftSmall);
export default ForwardRef;
